import axios from "axios";
// 基础封装
// axios.defaults.baseURL = 'http://jxx.zhenchangkj.com/v1';
axios.defaults.baseURL = "https://www.smeqh.cn/v1";

export default axios;
